import { isAriResourceIdValid } from '@atlassian/ui-modifications-public-api-utils/is-ari-resource-id-valid';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export type IssueTypePublicSetValue = string;

export const issueTypeSetValueValidator = (value: unknown): value is IssueTypePublicSetValue =>
	isNotEmptyString(value);

export const validateIssueTypeWithAriSetValue = (
	value: unknown,
): value is IssueTypePublicSetValue => isNotEmptyString(value) && isAriResourceIdValid(value);
